module.exports = __webpack_public_path__ + "239430156da74a8cc8880e7917644957.svg";